var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00299 10.8612V12.4953C7.27865 12.2451 6.50345 12.1684 5.74247 12.2715C4.98149 12.3747 4.25695 12.6547 3.6297 13.0881C3.00245 13.5215 2.49081 14.0956 2.13773 14.7622C1.78465 15.4289 1.60045 16.1685 1.6006 16.9191L2.06842e-07 16.9183C-0.000248184 15.9636 0.22322 15.0214 0.653283 14.1641C1.08335 13.3068 1.70859 12.557 2.4811 11.9723C3.25361 11.3875 4.15289 10.9833 5.11003 10.7906C6.06717 10.5979 7.05676 10.6218 8.00299 10.8604V10.8612ZM6.40239 9.88233C3.7494 9.88233 1.6006 7.78303 1.6006 5.19116C1.6006 2.5993 3.7494 0.5 6.40239 0.5C9.05538 0.5 11.2042 2.5993 11.2042 5.19116C11.2042 7.78303 9.05538 9.88233 6.40239 9.88233ZM6.40239 8.31861C8.17105 8.31861 9.60359 6.91908 9.60359 5.19116C9.60359 3.46325 8.17105 2.06372 6.40239 2.06372C4.63373 2.06372 3.2012 3.46325 3.2012 5.19116C3.2012 6.91908 4.63373 8.31861 6.40239 8.31861ZM11.0385 15.2881L13.8676 12.5242L15 13.6298L11.0385 17.5L8.20866 14.7353L9.34109 13.6298L11.0377 15.2881H11.0385Z",
    fill: "#505666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivate);
export default __webpack_public_path__ + "static/media/activate.f823bff0.svg";
export { ForwardRef as ReactComponent };